/* @flow */

import React, { Component } from 'react';
import type { $Configuration } from '../../types/Configuration';
import type { $DropdownOptions } from '../../types/DropdownOptions';
import type { $Translation } from '../../types/Translation';
import FilterType from '../../constants/FilterType';
import WBDropdown from '../WBDropdown/WBDropdown';
import { TemplateMarketPropertyKeys } from '../../templates/TemplateMarketProperties';
import { getConfigurationMarketProperty } from '../../utils/WidgetUtils';
import { mapDealerActivityTypeToTranslation } from '../../utils/DealerUtils';
import { sortFilterItemsList } from './DealersFilteringActivityTypesUtils';

type $Props = {
  appliedFilteringValues: Array<string>,
  configuration: $Configuration,
  defaultOptionLabel: string,
  dropdownDescriptionLabel?: string,
  handleFilterCheck: Function,
  marketCode: string,
  translations: Array<$Translation>
};

export default class DealersFilteringActivityTypesSSF extends Component<$Props> {
  render() {
    const activityTypes: $DropdownOptions = getFilterItemsList(
      this.props.marketCode, this.props.configuration, this.props.translations,
      TemplateMarketPropertyKeys.GEN_FILTERS_ACTIVITY_TYPES_ENABLED);

    return activityTypes.values && activityTypes.values.length > 0 ? (
      <WBDropdown
        descriptionLabel={this.props.dropdownDescriptionLabel}
        placeholder={this.props.defaultOptionLabel}
        labels={activityTypes.labels}
        values={activityTypes.values}
        selectedValue={this.props.appliedFilteringValues[0]}
        onChange={ (value: string) =>
          this.props.handleFilterCheck(FilterType.FILTER_ACTIVITY_TYPE, value? [value] : []) }
      />
    ) : null;
  }
}

export function getFilterItemsList(
  market: string, configuration: $Configuration, translations: Array<$Translation>, templatePropertyKey: string
): $DropdownOptions {
  const activityTypeOptions: $DropdownOptions = {
    labels: [],
    values: []
  };

  const enabledActivityTypes: Array<string> = getConfigurationMarketProperty(
    configuration, market, templatePropertyKey) || [];

  const activityTypesList: Array<string> = enabledActivityTypes;

  for (const activity of activityTypesList) {
    const activityTypeTranslation = mapDealerActivityTypeToTranslation(translations, activity);
    if (activityTypeTranslation) {
      activityTypeOptions.labels.push(activityTypeTranslation);
      activityTypeOptions.values.push(activity);
    }
  }

  return sortFilterItemsList(activityTypeOptions);
}
